export default defineNuxtRouteMiddleware(async (to) => {
  const { loggedIn, user, clear } = useUserSession();
  const config = useRuntimeConfig();

  if (loggedIn.value) {
    if (!user.value?.expires_in) {
      const baseUrl = config.public.baseUrl || ''; // Obtém a base URL do runtime config
      const callbackUrl = `${baseUrl}${to.fullPath || '/'}`; // Concatena a base URL com o caminho completo

      await clear();

      return await navigateTo(`/signin?callbackUrl=${encodeURIComponent(callbackUrl)}`);
    }

    if (user.value.expires_in) {
      const expiresAt = user.value.expires_in * 1000;
      const now = Date.now();

      const TWO_MINUTES = 2 * 60 * 1000;

      if (expiresAt - now < TWO_MINUTES) {
        await refreshTokenUtily(user.value.refresh_token);
      }
    }
  }

  return;
});
